module.exports = __webpack_public_path__ + "media/vlaamserand.c673465b.mp4";